import { render } from "./AddNewOrganization.vue?vue&type=template&id=6ef1d3de&scoped=true"
import script from "./AddNewOrganization.vue?vue&type=script&lang=js"
export * from "./AddNewOrganization.vue?vue&type=script&lang=js"

import "./AddNewOrganization.vue?vue&type=style&index=0&id=6ef1d3de&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef1d3de"]])

export default __exports__